import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  FaGlobe,
  FaCamera,
  FaChevronDown,
  FaChevronRight,
  FaChevronLeft,
  FaBars,
  FaTimes,
  FaHeart,
  FaRing,
  FaImages,
  FaLightbulb,
} from "react-icons/fa";

import "./Navbar.css";

function Navbar() {
  const { t, i18n } = useTranslation();

  const [openMenu, setOpenMenu] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isArabic = i18n.language === "ar";

  // =========================
  // TOGGLE MENU
  // =========================

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  // =========================
  // CHANGE LANGUAGE
  // =========================

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);

    localStorage.setItem("language", language);

    document.documentElement.dir =
      language === "ar" ? "rtl" : "ltr";

    document.documentElement.lang = language;
  };

  // =========================
  // CLOSE SIDEBAR
  // =========================

  const closeSidebar = () => {
    setSidebarOpen(false);
    setOpenMenu(null);
  };

  return (
    <>
      {/* ==================================================
          NAVBAR
      ================================================== */}

      <header className="navbar-container">

        <nav className="navbar">

          {/* =========================
              LOGO
          ========================= */}

          <Link to="/" className="logo">

            <img
              src="https://i.postimg.cc/B6xbCvXC/Logo-ph.jpg"
              alt="Photography Logo"
            />

          </Link>


          {/* ==================================================
              DESKTOP NAV
          ================================================== */}

          <ul className="nav-links">

            {/* HOME */}

            <li>
              <Link to="/">
                {t("nav.home")}
              </Link>
            </li>


            {/* ABOUT */}

            <li>
              <a href="/#about">
                {t("nav.about")}
              </a>
            </li>


            {/* ==================================================
                PHOTOGRAPHY
            ================================================== */}

            <li
              className="dropdown"
              onMouseEnter={() => setOpenMenu("photo")}
              onMouseLeave={() => setOpenMenu(null)}
            >

              <Link
                to="/photography"
                className="nav-dropdown-title"
              >

                <FaCamera />

                <span>
                  {t("nav.photography")}
                </span>

                <FaChevronDown className="arrow-icon" />

              </Link>


              {openMenu === "photo" && (

                <ul className="dropdown-menu">

                  {/* WEDDINGS */}

                  <li>
                    <Link
                      to="/gallery/Photography/Weddings"
                    >
                      <FaHeart />
                      {t("nav.weddings")}
                    </Link>
                  </li>


                  {/* ISLAMIC WEDDINGS */}

                  <li>
                    <Link
                      to="/gallery/Photography/Islamic%20Weddings"
                    >
                      <FaHeart />
                      {t("nav.islamicWeddings")}
                    </Link>
                  </li>


                  {/* ENGAGEMENTS */}

                  <li>
                    <Link
                      to="/gallery/Photography/Engagements"
                    >
                      <FaRing />
                      {t("nav.engagements")}
                    </Link>
                  </li>


                  {/* BRIDAL SESSIONS */}

                  <li>
                    <Link
                      to="/gallery/Photography/Bridal%20Sessions"
                    >
                      <FaCamera />
                      {t("nav.bridalSessions")}
                    </Link>
                  </li>


                  {/* WOMEN EVENTS */}

                  <li>
                    <Link
                      to="/gallery/Photography/Women%20Events"
                    >
                      <FaImages />
                      {t("nav.womenEvents")}
                    </Link>
                  </li>


                  {/* FAMILY & FRIENDS */}

                  <li>
                    <Link
                      to="/gallery/Photography/Family%20%26%20Friends"
                    >
                      <FaImages />
                      {t("nav.familyFriends")}
                    </Link>
                  </li>

                </ul>

              )}

            </li>


            {/* ==================================================
                RENTAL
            ================================================== */}

            <li
              className="dropdown"
              onMouseEnter={() => setOpenMenu("rental")}
              onMouseLeave={() => setOpenMenu(null)}
            >

              <Link
                to="/rental"
                className="nav-dropdown-title"
              >

                <FaCamera />

                <span>
                  {t("nav.rental")}
                </span>

                <FaChevronDown className="arrow-icon" />

              </Link>


              {openMenu === "rental" && (

                <ul className="dropdown-menu">

                  {/* BRIDAL ROBES */}

                  <li>
                    <Link
                      to="/rental/bridal-robes"
                    >
                      <FaCamera />
                      {t("nav.bridalRobes")}
                    </Link>
                  </li>


                  {/* BRIDESMAIDS */}

                  <li>
                    <Link
                      to="/rental/bridesmaids-robes"
                    >
                      <FaImages />
                      {t("nav.bridesmaids")}
                    </Link>
                  </li>


                  {/* ACCESSORIES */}

                 

                </ul>

              )}

            </li>


            {/* CONTACT */}

            <li>
              <a href="/contact">
                {t("nav.contact")}
              </a>
            </li>

          </ul>


          {/* ==================================================
              LANGUAGE SWITCHER
          ================================================== */}

          <div className="language-switcher">

            <FaGlobe className="language-icon" />

            <button
              className={
                i18n.language === "en"
                  ? "active"
                  : ""
              }
              onClick={() => changeLanguage("en")}
            >
              EN
            </button>

            <span className="language-divider">
              /
            </span>

            <button
              className={
                i18n.language === "ar"
                  ? "active"
                  : ""
              }
              onClick={() => changeLanguage("ar")}
            >
              AR
            </button>

          </div>


          {/* ==================================================
              MOBILE MENU BUTTON
          ================================================== */}

          <button
            className="menu-btn"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <FaBars />
          </button>

        </nav>


        <div className="nav-line" />

      </header>


      {/* ==================================================
          SIDEBAR OVERLAY
      ================================================== */}

      {sidebarOpen && (

        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
        />

      )}


      {/* ==================================================
          SIDEBAR
      ================================================== */}

      <aside
        className={`sidebar ${
          sidebarOpen ? "sidebar-open" : ""
        }`}
      >

        {/* =========================
            SIDEBAR HEADER
        ========================= */}

        <div className="sidebar-header">

          <img
            src="https://i.postimg.cc/B6xbCvXC/Logo-ph.jpg"
            alt="Photography Logo"
          />

          <button
            className="close-btn"
            onClick={closeSidebar}
          >
            <FaTimes />
          </button>

        </div>


        {/* ==================================================
            SIDEBAR LANGUAGE
        ================================================== */}

        <div className="sidebar-language">

          <div className="language-title">

            <FaGlobe />

            <span>
              {isArabic
                ? "اللغة"
                : "Language"}
            </span>

          </div>


          <div className="language-options">

            <button
              className={
                i18n.language === "en"
                  ? "active"
                  : ""
              }
              onClick={() =>
                changeLanguage("en")
              }
            >
              English
            </button>


            <button
              className={
                i18n.language === "ar"
                  ? "active"
                  : ""
              }
              onClick={() =>
                changeLanguage("ar")
              }
            >
              العربية
            </button>

          </div>

        </div>


        {/* ==================================================
            SIDEBAR LINKS
        ================================================== */}

        <ul className="sidebar-links">

          {/* HOME */}

          <li>

            <Link
              to="/"
              onClick={closeSidebar}
            >

              <span>
                {t("nav.home")}
              </span>

              {isArabic
                ? <FaChevronLeft />
                : <FaChevronRight />
              }

            </Link>

          </li>


          {/* ABOUT */}

          <li>

            <a
              href="/#about"
              onClick={closeSidebar}
            >

              <span>
                {t("nav.about")}
              </span>

              {isArabic
                ? <FaChevronLeft />
                : <FaChevronRight />
              }

            </a>

          </li>


          {/* ==================================================
              SIDEBAR PHOTOGRAPHY
          ================================================== */}

          <li className="sidebar-dropdown">

            <button
              onClick={() =>
                toggleMenu("sidePhoto")
              }
            >

              <span className="sidebar-main-title">

                <FaCamera />

                {t("nav.photography")}

              </span>


              <span className="plus-icon">

                {openMenu === "sidePhoto"
                  ? "−"
                  : "+"
                }

              </span>

            </button>


            {openMenu === "sidePhoto" && (

              <ul className="sidebar-submenu">

                {/* WEDDINGS */}

                <li>

                  <Link
                    to="/gallery/Photography/Weddings"
                    onClick={closeSidebar}
                  >

                    <FaHeart />

                    {t("nav.weddings")}

                  </Link>

                </li>


                {/* ISLAMIC WEDDINGS */}

                <li>

                  <Link
                    to="/gallery/Photography/Islamic%20Weddings"
                    onClick={closeSidebar}
                  >

                    <FaHeart />

                    {t("nav.islamicWeddings")}

                  </Link>

                </li>


                {/* ENGAGEMENTS */}

                <li>

                  <Link
                    to="/gallery/Photography/Engagements"
                    onClick={closeSidebar}
                  >

                    <FaRing />

                    {t("nav.engagements")}

                  </Link>

                </li>


                {/* BRIDAL SESSIONS */}

                <li>

                  <Link
                    to="/gallery/Photography/Bridal%20Sessions"
                    onClick={closeSidebar}
                  >

                    <FaCamera />

                    {t("nav.bridalSessions")}

                  </Link>

                </li>


                {/* WOMEN EVENTS */}

                <li>

                  <Link
                    to="/gallery/Photography/Women%20Events"
                    onClick={closeSidebar}
                  >

                    <FaImages />

                    {t("nav.womenEvents")}

                  </Link>

                </li>


                {/* FAMILY & FRIENDS */}

                <li>

                  <Link
                    to="/gallery/Photography/Family%20%26%20Friends"
                    onClick={closeSidebar}
                  >

                    <FaImages />

                    {t("nav.familyFriends")}

                  </Link>

                </li>

              </ul>

            )}

          </li>


          {/* ==================================================
              SIDEBAR RENTAL
          ================================================== */}

          <li className="sidebar-dropdown">

            <button
              onClick={() =>
                toggleMenu("sideRental")
              }
            >

              <span className="sidebar-main-title">

                <FaCamera />

                {t("nav.rental")}

              </span>


              <span className="plus-icon">

                {openMenu === "sideRental"
                  ? "−"
                  : "+"
                }

              </span>

            </button>


            {openMenu === "sideRental" && (

              <ul className="sidebar-submenu">

                {/* BRIDAL ROBES */}

                <li>

                  <Link
                    to="/rental/bridal-robes"
                    onClick={closeSidebar}
                  >

                    <FaCamera />

                    {t("nav.bridalRobes")}

                  </Link>

                </li>


                {/* BRIDESMAIDS */}

                <li>

                  <Link
                    to="/rental/bridesmaids-robes"
                    onClick={closeSidebar}
                  >

                    <FaImages />

                    {t("nav.bridesmaids")}

                  </Link>

                </li>


            

              </ul>

            )}

          </li>


          {/* CONTACT */}

          <li>

            <a
              href="/#contact"
              onClick={closeSidebar}
            >

              <span>
                {t("nav.contact")}
              </span>

              {isArabic
                ? <FaChevronLeft />
                : <FaChevronRight />
              }

            </a>

          </li>

        </ul>

      </aside>
    </>
  );
}

export default Navbar;